import React from 'react';

import { MrAppLayout, MrAppMain } from '@ion/components';
import { useTrackPage } from '@ion/api';

import SideNav from 'app/components/side-nav';
import Header from 'app/components/app-header';
import RedirectFeatureGate from 'app/launch-darkly/gates/redirect-feature-gate';
import { FEATURE_FLAGS } from 'app/launch-darkly/featureFlags';

import { AnalyticsFilesTableContextProvider } from './AnalyticsFilesTable/AnalyticsFilesTableContext';
import AnalyticsFilesTable from './AnalyticsFilesTable';

export default function AnalyticsFilesPage() {
  useTrackPage('analytics_files_list_page_viewed');

  return (
    <RedirectFeatureGate flagName={FEATURE_FLAGS.analyticsFilesListViewMvp}>
      <MrAppLayout
        title="Analytics Files"
        description="Manage your analytics files."
        sideNav={<SideNav />}
        header={<Header icon="analyticsFiles" title="Analytics Files" />}
      >
        <MrAppMain>
          <AnalyticsFilesTableContextProvider>
            <AnalyticsFilesTable />
          </AnalyticsFilesTableContextProvider>
        </MrAppMain>
      </MrAppLayout>
    </RedirectFeatureGate>
  );
}
